<template>
	<div>
		<el-drawer
			:visible.sync="dialogVisible"
			:wrapperClosable="false"
			:append-to-body="true"
			:close-on-press-escape="false"
			size="600px"
			:before-close="handleClose"
		>
			<div slot="title" class="font-h4-medium yx-color-text-primary">
				{{ `${!id ? '添加' : '编辑'}团长${id ? '信息' : ''}` }}
			</div>
			<div class="formBox">
				<div class="flex-row-align-center">
					<div class="icon"></div>
					<div class="font-h4-medium yx-color-text-primary ml-10">团长信息</div>
				</div>
				<el-form class="mt-16" :model="form" ref="ruleForm" label-width="130px">
					<!-- <el-form-item label="平台">
				<platform-select v-model="form.platform_id"></platform-select>
			</el-form-item> -->
					<el-form-item prop="institutionName">
						<div slot="label">
							<span class="yx-color-danger mr-4">*</span>
							<span>团长名称</span>
						</div>
						<el-input v-model="form.institutionName" maxlength="10" show-word-limit placeholder="请填写" />
					</el-form-item>
					<el-form-item prop="outerActivityId" v-if="!id">
						<div slot="label">
							<span class="yx-color-danger mr-4">*</span>
							<span>团长活动id</span>
						</div>
						<el-input type="textarea" v-model.trim="form.outerActivityId" placeholder="请输入团长活动id" />
						<div class="font-h6-regular yx-color-primary cursor-pointer" @click="goToUrl">如何获取团长活动id？</div>
					</el-form-item>
					<el-form-item prop="userIds" v-if="$auth.hasPermi('system:cooperativeColonel:switch')">
						<div slot="label">
							<span class="yx-color-danger mr-4">*</span>
							<span>跟进人</span>
						</div>
						<el-select v-model="form.userIds" clearable placeholder="请选择跟进人" :multiple="manyPartnerToInstitution === '1'">
							<el-option v-for="item in partner_list" :key="item.userId" :label="item.name" :value="item.userId">
								<div class="flex-row-align-center">
									<span class="mr-8">{{ item.name }}</span>
									<el-tag v-if="item.deleted" type="danger" size="mini" effect="plain">账号已删除</el-tag>
									<el-tag v-else-if="item.use_status === '2'" type="danger" size="mini">账号已停用</el-tag>
								</div>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="跟进人" v-else>
						<el-input :value="vuex_userInfo.partner_role_name" disabled />
					</el-form-item>
					<el-form-item label="备注">
						<el-input type="textarea" v-model="form.remark" maxlength="100" show-word-limit placeholder="请填写" />
					</el-form-item>
				</el-form>
			</div>
			<div class="bott">
				<el-button @click="handleClose">取 消</el-button>
				<el-button type="primary" @click="submit" :disabled="isDisable">保存</el-button>
			</div>
		</el-drawer>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import throttle from 'lodash/throttle';
import { drRoleType } from '@/utils/dataMap';
import { commonList } from '@/api/cooperationProgress';
import { institutionCreate, institutionEdit, institutionDetail, GetRule } from '@/api/secondColonelManage';
export default {
	name: 'partnerDialog',
	props: {
		platformId: {
			type: [String, Number],
			default: +dataMap.PLATFORM_KS.value,
		},
	},
	data() {
		return {
			dialogVisible: false,
			partner_list: [],
			form: {
				institutionName: '',
				outerActivityId: '',
				userIds: '',
				remark: '',
			},
			id: '',
			manyPartnerToInstitution: '0',
		};
	},
	computed: {
		...mapState(['vuex_userInfo']),
		...mapGetters(['hasDrPartnerTagAndSelfDataScope', 'hasDeptDataScope']),
		isDisable({ id, form }) {
			const { institutionName, outerActivityId, userIds } = form;
			const userIdCheck = this.$auth.hasPermi('system:cooperativeColonel:switch') ? userIds.length : true;
			return id ? !(institutionName && userIdCheck) : !(institutionName && outerActivityId && userIdCheck);
		},
	},
	methods: {
		show(id = '') {
			this.GetRule();
			this.id = id;
			this.dialogVisible = true;
		},
		handleClose() {
			this.form = {
				institutionName: '',
				outerActivityId: '',
				userIds: '',
				remark: '',
			};
			this.id = '';
			this.$refs.ruleForm.resetFields();
			this.dialogVisible = false;
		},
		async GetRule() {
			const { platformId } = this;
			const { manyPartnerToInstitution = '0' } = await GetRule({ platformId });
			this.manyPartnerToInstitution = `${manyPartnerToInstitution}`;
			if (this.manyPartnerToInstitution === '1') {
				this.form.userIds = [];
			} else {
				this.form.userIds = '';
			}
			this.partnerList();
			if (this.id) this.institutionDetail();
		},
		async institutionDetail() {
			const { id } = this;
			const { code, data = {} } = await institutionDetail({ teamInstitutionId: id });
			if (code !== 0) return;
			Object.keys(this.form).forEach(key => {
				this.form[key] = data[key];
			});
			//允许多跟进达人规则支持多选，否则单选
			this.form.userIds = this.manyPartnerToInstitution === '1' ? data['userIds']?.map(item => `${item}`) || [] : `${data['userIds'][0]}`;
		},
		async partnerList() {
			//delete0所有， 1未删除，2删除
			const { code, data = [] } = await commonList({ role_id: drRoleType.id, all_status: 1, delete: 1 });
			if (code !== 0) return;
			this.partner_list = data;
			if (!this.$auth.hasPermi('system:cooperativeColonel:switch')) {
				let name = this.vuex_userInfo.partner_role_name;
				let userIds = [];
				this.partner_list.forEach(item => {
					if (item.name === name) {
						userIds.push(item.userId);
					}
				});
				this.form.userIds = userIds[0];
			}
		},
		goToUrl() {
			window.open('https://sviptrader.yuque.com/docs/share/66c1321e-218b-45f4-bf19-f6946d28947a?#');
		},
		submit: throttle(function () {
			this.$refs.ruleForm.validate(async valid => {
				if (valid) {
					const { form, id, platformId } = this;
					const { userIds: list, ...params } = form;
					await (!id
						? institutionCreate({ ...params, userIds: Array.isArray(list) ? list : [list], platformId })
						: institutionEdit({ ...params, teamInstitutionId: id, userIds: Array.isArray(list) ? list : [list], platformId }));
					this.$message.success(`${!id ? '添加' : '编辑'}成功`);
					this.$emit('refresh');
					this.handleClose();
				}
			});
		}, 1000),
	},
};
</script>

<style lang="less" scoped>
.formBox {
	padding: 24px 24px 80px 24px;
	.icon {
		width: 4px;
		height: 16px;
		border-radius: 14px;
		background-color: @color-primary;
	}
	/deep/ .el-select {
		width: 100%;
	}
}
.bott {
	position: absolute;
	bottom: 0;
	height: 64px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-right: 20px;
	width: 100%;
	/* 超/灰/G1 */
	background: #ffffff;
	box-shadow: 0px -2px 10px 0px rgba(0, 0, 0, 0.1);
	/deep/ .el-button--small {
		padding: 0 28px;
	}
}
</style>
